import { render, staticRenderFns } from "./addmodal.vue?vue&type=template&id=595d3c14&scoped=true&"
import script from "./addmodal.vue?vue&type=script&lang=js&"
export * from "./addmodal.vue?vue&type=script&lang=js&"
import style0 from "./addmodal.vue?vue&type=style&index=0&id=595d3c14&scoped=true&lang=css&"
import style1 from "./addmodal.vue?vue&type=style&index=1&id=595d3c14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d3c14",
  null
  
)

export default component.exports